import { z, ZodSchema } from "zod";
import { usernameSchema } from "../Auth/types";

export enum ClinicMemberStatus {
  Active = 1,
  Pending = 2,
}

export interface ClinicMember {
  id: string;
  name: string;
  email: string;
  role: number;
  status: ClinicMemberStatus;
}

export interface FormData {
  fields: {
    name?: string;
    address?: string;
  };
}

export interface InviteFormData {
  username: string;
  email: string;
  role: number;
}

export interface FormResponse {
  clinic: {
    updated: string;
  };
}

export const schema: ZodSchema<FormData> = z.object({
  fields: z.object({
    address: z
      .string({ message: "errors.address.required" })
      .min(1, { message: "errors.address.required" })
      .max(256, { message: "errors.address.required" })
      .optional(),
    name: z
      .string({ message: "errors.name.required" })
      .min(1, { message: "errors.name.required" })
      .max(128, { message: "errors.name.required" })
      .optional(),
  }),
});

export const inviteSchema: ZodSchema<InviteFormData> = z.object({
  email: z
    .string()
    .email({ message: "sections.members.errors.email.required" }),
  role: z
    .number({ message: "sections.members.errors.role.required" })
    .int()
    .min(0, { message: "sections.members.errors.role.required" }),
  username: z.string().min(1, { message: "errors.username.required" }),
});

export interface InviteFormResponse {
  created: string;
}

export interface ClinicDetailsResponse {
  id: string;
  name: string;
  address: string;
  config: string;
  created: string;
  updated: string;
}

export interface ClinicMembersResponse {
  next_page_token: string | null;
  users: ClinicMember[];
}
